import classNames from 'classnames'
import { ReactNode } from 'react'

const spans = {
  sm: 4,
  md: 6,
  lg: 8,

  xl: 10,
  xxl: 11,
}
export const Card = (props: {
  width?: keyof typeof spans
  height?: number
  title: string
  children?: ReactNode
  classNames?: string
  variant?: 'grid' | 'flex'
}) => {
  const width = props.width ?? 'md'
  const flexVariant =
    'flex flex-col shadow-[0_3px_6px_rgba(0,0,0,0.16),0_3px_6px_rgba(0,0,0,0.23)]   sm:h-fit lg:h-auto bg-white p-6 '
  const gridStyleVariant = {
    gridColumn: `span ${spans[width]}`,
    gridRow: `span ${props.height ?? ''}`,
  }
  return (
    <div
      className={classNames(
        props.variant == 'flex' ? flexVariant : ' shadow-md p-6 bg-white overflow-auto',
        props.classNames
      )}
      style={props.variant == 'flex' ? {} : gridStyleVariant}
    >
      <h2 className="text-xl font-medium mb-4">{props.title}</h2>
      {props.children}
    </div>
  )
}
